import { render } from "./DbaWizard.vue?vue&type=template&id=76b109d0"
import script from "./DbaWizard.vue?vue&type=script&lang=js"
export * from "./DbaWizard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__